export default function () {
  return [{
    id: 1,
    name: 'Secretaria de Segurança Pública',
    codigo: 'SSP'
  },
  {
    id: 2,
    name: 'Polícia Civil',
    codigo: 'PC'
  },
  {
    id: 3,
    name: 'Polícia Militar',
    codigo: 'PM'
  },
  {
    id: 4,
    name: 'Polícia Federal',
    codigo: 'PF'
  },
  {
    id: 5,
    name: 'Outros',
    codigo: 'OUTROS'
  }
  ]
}



// WEBPACK FOOTER //
// ./src/constants/orgaosExpedidores.js